import { useParams, useSearchParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import Footer from '@/components/feature/Footer';
import { comics } from '@/mocks/comics';

const readerPages = [
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20style%2C%20manga%20panel%20layout%2C%20dramatic%20scene%20with%20characters%2C%20speech%20bubbles%2C%20action%20composition%2C%20clean%20lineart%2C%20webtoon%20format%2C%20grayscale%20tone%2C%20cinematic%20panel%20arrangement%2C%20dynamic%20angles%2C%20detailed%20background&width=900&height=1300&seq=reader-p-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comic%20page%20layout%2C%20dialogue%20scene%20with%20two%20characters%2C%20emotional%20exchange%2C%20speech%20bubbles%2C%20webtoon%20format%2C%20grayscale%20illustration%2C%20detailed%20facial%20expressions%2C%20clean%20lineart%2C%20cinematic%20framing&width=900&height=1300&seq=reader-p-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20page%2C%20dynamic%20fight%20scene%2C%20speed%20lines%2C%20impact%20effects%2C%20dramatic%20composition%2C%20webtoon%20vertical%20format%2C%20grayscale%20art%2C%20powerful%20poses%2C%20detailed%20action%20panels&width=900&height=1300&seq=reader-p-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20panel%20with%20closeup%20face%2C%20shocked%20expression%2C%20dramatic%20lighting%2C%20screen%20tone%2C%20webtoon%20style%2C%20grayscale%20illustration%2C%20emotional%20moment%2C%20detailed%20eyes%2C%20intense%20atmosphere&width=900&height=1300&seq=reader-p-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20wide%20establishing%20shot%2C%20cityscape%20background%2C%20characters%20in%20urban%20setting%2C%20detailed%20architecture%2C%20webtoon%20format%2C%20grayscale%20art%2C%20atmospheric%20scene%2C%20cinematic%20composition&width=900&height=1300&seq=reader-p-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20scene%2C%20couple%20moment%2C%20flower%20petals%2C%20soft%20atmosphere%2C%20webtoon%20vertical%20layout%2C%20grayscale%20illustration%2C%20gentle%20expressions%2C%20romantic%20composition%2C%20clean%20lineart&width=900&height=1300&seq=reader-p-06&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20magic%20scene%2C%20energy%20effects%2C%20supernatural%20elements%2C%20glowing%20particles%2C%20webtoon%20format%2C%20grayscale%20art%2C%20dynamic%20composition%2C%20epic%20atmosphere&width=900&height=1300&seq=reader-p-07&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20setting%2C%20classroom%20scene%2C%20students%20interaction%2C%20slice%20of%20life%2C%20webtoon%20format%2C%20grayscale%20illustration%2C%20casual%20atmosphere%2C%20clean%20composition&width=900&height=1300&seq=reader-p-08&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20night%20scene%2C%20moonlight%20atmosphere%2C%20mysterious%20silhouette%2C%20dramatic%20lighting%2C%20webtoon%20format%2C%20grayscale%20art%2C%20suspenseful%20composition%2C%20detailed%20shadows&width=900&height=1300&seq=reader-p-09&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20scene%2C%20funny%20expressions%2C%20chibi%20style%20moments%2C%20playful%20atmosphere%2C%20webtoon%20format%2C%20grayscale%20illustration%2C%20lighthearted%20panels&width=900&height=1300&seq=reader-p-10&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20panel%20full%20body%20character%20pose%2C%20dramatic%20stance%2C%20flowing%20hair%2C%20wind%20effect%2C%20webtoon%20vertical%20layout%2C%20grayscale%20art%2C%20heroic%20composition&width=900&height=1300&seq=reader-p-11&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20emotional%20crying%20scene%2C%20teardrops%2C%20touching%20moment%2C%20dramatic%20closeup%2C%20webtoon%20format%2C%20grayscale%20illustration%2C%20heartfelt%20expression%2C%20detailed%20emotion&width=900&height=1300&seq=reader-p-12&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20transformation%20scene%2C%20power%20awakening%2C%20energy%20burst%2C%20dramatic%20reveal%2C%20webtoon%20format%2C%20grayscale%20art%2C%20epic%20moment%2C%20dynamic%20composition&width=900&height=1300&seq=reader-p-13&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20dialogue%20scene%20group%20conversation%2C%20multiple%20characters%2C%20varied%20expressions%2C%20webtoon%20format%2C%20grayscale%20illustration%2C%20story%20progression%2C%20clean%20composition&width=900&height=1300&seq=reader-p-14&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cliffhanger%20ending%2C%20dramatic%20reveal%2C%20shocking%20moment%2C%20silhouette%20mystery%2C%20webtoon%20format%2C%20grayscale%20art%2C%20suspenseful%20panel%2C%20intense%20atmosphere&width=900&height=1300&seq=reader-p-15&orientation=portrait',
];

export default function ReaderPage() {
  const { slug } = useParams<{ slug: string }>();
  const [searchParams] = useSearchParams();
  const chapterNum = parseInt(searchParams.get('chapter') || '1', 10);

  const comic = comics.find((c) => c.slug === slug);

  const [showControls, setShowControls] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const handleScroll = () => {
      setShowControls(false);
      clearTimeout(timer);
      timer = setTimeout(() => setShowControls(true), 2000);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, []);

  if (!comic) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200 mb-4">
            <i className="ri-error-warning-line text-2xl text-foreground-400"></i>
          </div>
          <h1 className="text-xl font-semibold text-foreground-950 mb-2">漫画未找到</h1>
          <Link to="/" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium">
            <i className="ri-arrow-left-line"></i>返回首页
          </Link>
        </div>
      </div>
    );
  }

  const totalPages = readerPages.length;
  const hasPrevChapter = chapterNum > 1;
  const hasNextChapter = chapterNum < comic.chapters;
  const progress = Math.round(((currentPage + 1) / totalPages) * 100);

  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        headline: `${comic.title} 第${chapterNum}话 - 韩漫画免费阅读`,
        description: `在线免费阅读${comic.title}第${chapterNum}话，韩漫画下拉式阅读体验，高清画质。`,
        author: { '@type': 'Person', name: comic.author },
        datePublished: '2024-01-01',
        dateModified: comic.updatedAt,
        isPartOf: { '@type': 'WebSite', name: 'ManhwaFun' },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://costrebate.com/' },
          { '@type': 'ListItem', position: 2, name: comic.categoryName, item: `http://costrebate.com/category/${comic.category}` },
          { '@type': 'ListItem', position: 3, name: comic.title, item: `http://costrebate.com/comic/${comic.slug}` },
          { '@type': 'ListItem', position: 4, name: `第${chapterNum}话`, item: `http://costrebate.com/comic/${comic.slug}/read?chapter=${chapterNum}` },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={`${comic.title} 第${chapterNum}话 - 韩漫画免费阅读`}
        description={`在线免费阅读${comic.title}第${chapterNum}话，韩漫画下拉式阅读体验，看漫画下拉式，高清画质。`}
        keywords={`${comic.title},第${chapterNum}话,韩漫画免费阅读,看漫画下拉式,好看的韩国漫画大全`}
        canonical={`http://costrebate.com/comic/${comic.slug}/read?chapter=${chapterNum}`}
        ogTitle={`${comic.title} 第${chapterNum}话 - 韩漫画免费阅读`}
        ogDescription={`在线免费阅读${comic.title}第${chapterNum}话，韩漫画下拉式阅读体验。`}
        ogUrl={`http://costrebate.com/comic/${comic.slug}/read?chapter=${chapterNum}`}
        schemaData={schemaData}
      />

      <div className={`fixed top-0 left-0 w-full z-50 transition-transform duration-300 ${
        showControls ? 'translate-y-0' : '-translate-y-full'
      }`}>
        <div className="bg-background-50/95 backdrop-blur-md border-b border-background-200">
          <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Link
                to={`/comic/${comic.slug}`}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-background-300 transition-colors"
                aria-label="返回详情"
              >
                <i className="ri-arrow-left-line text-foreground-700"></i>
              </Link>
              <div>
                <p className="text-sm font-semibold text-foreground-950 leading-tight">{comic.title}</p>
                <p className="text-xs text-foreground-400">第{chapterNum}话</p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <span className="text-xs text-foreground-400">{progress}%</span>
            </div>
          </div>
        </div>
      </div>

      <main className="bg-background-950 min-h-screen">
        <div className="max-w-[720px] mx-auto">
          {readerPages.map((page, index) => (
            <div
              key={index}
              className="w-full"
              onMouseEnter={() => setCurrentPage(index)}
            >
              <img
                src={page}
                alt={`${comic.title} 第${chapterNum}话 - 第${index + 1}页`}
                title={`${comic.title} - 韩漫画免费阅读 第${index + 1}页`}
                className="w-full h-auto"
                loading={index < 3 ? 'eager' : 'lazy'}
              />
            </div>
          ))}

          <div className="py-16 text-center">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-background-800 mb-3">
              <i className="ri-check-line text-xl text-background-400"></i>
            </div>
            <p className="text-background-400 text-sm mb-6">第{chapterNum}话 完</p>
          </div>
        </div>
      </main>

      <div className={`fixed bottom-0 left-0 w-full z-50 transition-transform duration-300 ${
        showControls ? 'translate-y-0' : 'translate-y-full'
      }`}>
        <div className="bg-background-50/95 backdrop-blur-md border-t border-background-200">
          <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-background-300 transition-colors"
              aria-label="回到顶部"
            >
              <i className="ri-arrow-up-line text-foreground-700"></i>
            </button>

            <div className="flex items-center gap-2">
              {hasPrevChapter && (
                <Link
                  to={`/comic/${comic.slug}/read?chapter=${chapterNum - 1}`}
                  className="px-4 py-2 rounded-full text-xs font-medium bg-background-200 text-foreground-700 hover:bg-background-300 transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-left-s-line"></i>上一话
                </Link>
              )}

              <Link
                to={`/comic/${comic.slug}`}
                className="px-4 py-2 rounded-full text-xs font-medium bg-background-200 text-foreground-700 hover:bg-background-300 transition-colors whitespace-nowrap"
              >
                <i className="ri-list-check mr-1"></i>目录
              </Link>

              {hasNextChapter && (
                <Link
                  to={`/comic/${comic.slug}/read?chapter=${chapterNum + 1}`}
                  className="px-4 py-2 rounded-full text-xs font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  下一话<i className="ri-arrow-right-s-line"></i>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}